import { render, staticRenderFns } from "./crossProduct.vue?vue&type=template&id=1bead3b3&scoped=true"
import script from "./crossProduct.vue?vue&type=script&lang=js"
export * from "./crossProduct.vue?vue&type=script&lang=js"
import style0 from "./crossProduct.vue?vue&type=style&index=0&id=1bead3b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bead3b3",
  null
  
)

export default component.exports